module.exports = __webpack_public_path__ + "img/26.acaa1ee4.png";